import React from 'react'
import PropTypes from 'prop-types'

export const IconFacebook = ({ className }) => (
  <svg
    role="img"
    aria-label={'Facebook'}
    className={'icon icon-facebook ' + className}
    version="1.1"
    viewBox="4 4 23 21"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <path
      fill="#3d5a96"
      className={'fill-current'}
      d="M26.462 14.151c0 5.778-4.684 10.462-10.462 10.462s-10.462-4.684-10.462-10.462c0-5.778 4.684-10.462 10.462-10.462s10.462 4.684 10.462 10.462z"
    />
    <path
      fill="#fff"
      className={'fill-white'}
      d="M16.551 18.533h-1.876v-3.997h-0.938v-1.538h0.938v-0.923c0-1.255 0.529-2.003 2.031-2.003h1.255v1.536h-0.783c-0.586 0-0.625 0.215-0.625 0.615v0.77h1.415l-0.166 1.538h-1.252v3.997z"
    />
  </svg>
)

export const IconTwitter = ({ className }) => (
  <svg
    role="img"
    aria-label={'Twitter'}
    className={'icon icon-twitter ' + className}
    version="1.1"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <path
      fill="#2aa3ef"
      className={'fill-current'}
      d="M26.462 14.154c0 5.778-4.684 10.462-10.462 10.462s-10.462-4.684-10.462-10.462c0-5.778 4.684-10.462 10.462-10.462s10.462 4.684 10.462 10.462z"
    />
    <path
      fill="#fff"
      className={'fill-white'}
      d="M20.305 11.517c-0.295 0.134-0.638 0.232-0.998 0.276l-0.017 0.002c0.365-0.221 0.64-0.561 0.773-0.965l0.004-0.013c-0.323 0.196-0.699 0.345-1.099 0.427l-0.023 0.004c-0.323-0.344-0.781-0.558-1.289-0.558-0.975 0-1.766 0.79-1.767 1.764v0c0 0.143 0.017 0.282 0.049 0.415l-0.002-0.012c-1.472-0.076-2.766-0.775-3.634-1.837l-0.007-0.009c-0.15 0.255-0.239 0.561-0.239 0.888 0 0.61 0.309 1.148 0.779 1.466l0.006 0.004c-0.295-0.009-0.569-0.089-0.808-0.224l0.009 0.005v0.023c0 0 0 0 0 0 0 0.851 0.602 1.562 1.404 1.729l0.011 0.002c-0.139 0.039-0.298 0.062-0.462 0.062-0.001 0-0.003 0-0.004 0h0c-0 0-0 0-0 0-0.117 0-0.232-0.012-0.343-0.034l0.011 0.002c0.233 0.708 0.882 1.212 1.651 1.226l0.002 0c-0.597 0.471-1.36 0.756-2.189 0.756-0.002 0-0.004 0-0.005 0h0c-0.001 0-0.002 0-0.004 0-0.147 0-0.293-0.009-0.435-0.026l0.017 0.002c0.764 0.498 1.699 0.794 2.703 0.794 0.002 0 0.003 0 0.005 0h-0c0.010 0 0.023 0 0.035 0 2.757 0 4.992-2.235 4.992-4.992 0-0.013-0-0.025-0-0.038v0.002c0-0.077 0-0.153-0.005-0.228 0.347-0.253 0.639-0.556 0.873-0.901l0.008-0.013z"
    />
  </svg>
)

export const IconGooglePlus = ({ className }) => (
  <svg
    role="img"
    aria-label={'Google Plus'}
    className={'icon icon-google-plus ' + className}
    version="1.1"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <path
      fill="#da483f"
      className={'fill-[#da483f]'}
      d="M26.465 14.156c0 5.778-4.684 10.462-10.462 10.462s-10.462-4.684-10.462-10.462c0-5.778 4.684-10.462 10.462-10.462s10.462 4.684 10.462 10.462z"
    />
    <path
      fill="#fff"
      className={'fill-white'}
      d="M14.142 17.326c-0.005 0-0.011 0-0.018 0-0.912 0-1.739-0.362-2.346-0.95l0.001 0.001c-0.603-0.578-0.978-1.391-0.978-2.291s0.375-1.713 0.977-2.29l0.001-0.001c0.612-0.587 1.445-0.948 2.362-0.948 0.865 0 1.655 0.322 2.257 0.852l-0.004-0.003-0.983 0.935c-0.342-0.281-0.785-0.451-1.267-0.451-0.001 0-0.002 0-0.003 0h0c-0.009-0-0.019-0-0.030-0-1.060 0-1.922 0.85-1.939 1.906l-0 0.002c0.018 1.057 0.879 1.908 1.939 1.908 0.010 0 0.021-0 0.031-0l-0.002 0c0.002 0 0.005 0 0.008 0 0.823 0 1.528-0.503 1.826-1.218l0.005-0.013h-1.881v-1.354h3.31c0.046 0.203 0.073 0.436 0.073 0.675 0 0.9-0.375 1.713-0.977 2.291l-0.001 0.001c-0.606 0.587-1.433 0.949-2.345 0.949-0.006 0-0.012-0-0.018-0h0.001zM20.169 15.461h-0.846v-1.129h-1.163v-0.82h1.163v-1.127h0.846v1.127h1.163v0.82h-1.163v1.129z"
    />
  </svg>
)

export const IconPinterest = ({ className }) => (
  <svg
    role="img"
    aria-label={'Pinterest'}
    className={'icon  ' + className}
    version="1.1"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <path
      fill="#fff"
      className={'fill-current'}
      d="M16 2.138c-7.656 0-13.863 6.206-13.863 13.863 0 5.875 3.656 10.887 8.813 12.906-0.119-1.094-0.231-2.781 0.050-3.975 0.25-1.081 1.625-6.887 1.625-6.887s-0.412-0.831-0.412-2.056c0-1.925 1.119-3.369 2.506-3.369 1.181 0 1.756 0.887 1.756 1.95 0 1.188-0.756 2.969-1.15 4.613-0.331 1.381 0.688 2.506 2.050 2.506 2.462 0 4.356-2.6 4.356-6.35 0-3.319-2.387-5.638-5.787-5.638-3.944 0-6.256 2.956-6.256 6.019 0 1.194 0.456 2.469 1.031 3.163 0.113 0.137 0.131 0.256 0.094 0.4-0.106 0.438-0.338 1.381-0.387 1.575-0.063 0.256-0.2 0.306-0.463 0.188-1.731-0.806-2.813-3.337-2.813-5.369 0-4.375 3.175-8.387 9.156-8.387 4.806 0 8.544 3.425 8.544 8.006 0 4.775-3.012 8.625-7.194 8.625-1.406 0-2.725-0.731-3.175-1.594 0 0-0.694 2.644-0.863 3.294-0.313 1.206-1.156 2.712-1.725 3.631 1.3 0.4 2.675 0.619 4.106 0.619 7.656 0 13.863-6.206 13.863-13.863 0-7.662-6.206-13.869-13.863-13.869z"
    />
  </svg>
)

export const IconYouTube = ({ className }) => (
  <svg
    role="img"
    aria-label={'Youtube'}
    className={'icon  ' + className}
    version="1.1"
    viewBox="4 4 23 21"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <path
      fill="#f52929"
      className={'fill-current'}
      d="M26.464 14.155c0 5.778-4.684 10.463-10.463 10.463s-10.463-4.684-10.463-10.463c0-5.778 4.684-10.463 10.463-10.463s10.463 4.684 10.463 10.463z"
    />
    <path
      fill="#fff"
      className={'fill-white'}
      d="M16 17.909v0c-0.025 0-2.523-0.018-3.28-0.102-0.041-0.010-0.090-0.017-0.148-0.025-0.365-0.022-0.687-0.185-0.917-0.435l-0.001-0.001c-0.195-0.302-0.331-0.66-0.381-1.045l-0.001-0.013c-0.059-0.512-0.095-1.111-0.1-1.717l-0-0.007v-0.8c0-0.861 0.099-1.733 0.1-1.741 0.042-0.4 0.18-0.761 0.389-1.069l-0.005 0.008c0.232-0.26 0.564-0.427 0.935-0.44l0.002-0h0.027c1.334-0.105 3.362-0.123 3.382-0.123s2.048 0.018 3.38 0.119l0.046 0.004c0.37 0.006 0.7 0.175 0.921 0.438l0.002 0.002c0.195 0.302 0.331 0.66 0.381 1.045l0.001 0.013c0 0.009 0.1 0.882 0.1 1.741v0.8c0 0.842-0.099 1.715-0.1 1.723-0.052 0.398-0.187 0.756-0.389 1.068l0.006-0.010c-0.232 0.26-0.564 0.427-0.935 0.441l-0.002 0h-0.027c-1.338 0.126-3.364 0.127-3.384 0.127zM14.834 12.428v3.706l3.166-1.81z"
    />
  </svg>
)

export const IconYouTubePlayBtn = ({ className }) => (
  <svg
    role="img"
    aria-label={'Youtube Play Button'}
    className={'icon  ' + className}
    version="1.1"
    viewBox="0 0 32.8 23.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <path
      fill="#f52929"
      className={'fill-current'}
      d="M32.1,5.2s-.3-2.2-1.3-3.2c-1.2-1.3-2.6-1.3-3.2-1.4-4.5-.3-11.2-.3-11.2-.3h0s-6.7,0-11.2.3c-.6,0-2,0-3.2,1.4-1,1-1.3,3.2-1.3,3.2,0,0-.3,2.6-.3,5.2v2.4c0,2.6.3,5.2.3,5.2,0,0,.3,2.2,1.3,3.2,1.2,1.3,2.8,1.2,3.5,1.4,2.6.2,10.9.3,10.9.3,0,0,6.7,0,11.2-.3.6,0,2,0,3.2-1.4,1-1,1.3-3.2,1.3-3.2,0,0,.3-2.6.3-5.2v-2.4c0-2.6-.3-5.2-.3-5.2h0ZM13.1,15.8V6.8l8.6,4.5s-8.6,4.5-8.6,4.5Z"
    />
    <path fill="#fff" className={'fill-white'} d="M13.1,15.8V6.8l8.6,4.5s-8.6,4.5-8.6,4.5Z" />
  </svg>
)

export const IconInstagram = ({ className }) => (
  <svg
    role="img"
    aria-label={'Instagram'}
    className={'icon ' + className}
    version="1.1"
    viewBox="6 4 20 20"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <path
      fill="#000"
      className={'fill-current'}
      d="M25.379 13.793c0 5.18-4.199 9.379-9.379 9.379s-9.379-4.199-9.379-9.379c0-5.18 4.199-9.379 9.379-9.379s9.379 4.199 9.379 9.379z"
    />
    <path
      fill="#fff"
      className={'fill-white'}
      d="M17.624 17.863h-3.318c-1.35-0.002-2.444-1.095-2.445-2.445v-3.318c0.002-1.35 1.095-2.444 2.445-2.445h3.318c1.35 0.002 2.444 1.095 2.445 2.445v3.318c-0.002 1.35-1.095 2.444-2.445 2.445h-0zM14.306 10.482c-0.893 0.002-1.615 0.725-1.618 1.617v3.318c0.001 0.894 0.726 1.618 1.62 1.619h3.318c0.894-0.001 1.618-0.726 1.619-1.619v-3.318c-0.002-0.894-0.727-1.618-1.622-1.618 0 0 0 0 0 0v0zM15.965 15.884c-1.173 0-2.123-0.95-2.123-2.123s0.95-2.123 2.123-2.123c1.173 0 2.123 0.95 2.123 2.123v0c-0.002 1.171-0.952 2.12-2.123 2.121h-0zM15.965 12.463c-0.716 0-1.297 0.581-1.297 1.297s0.581 1.297 1.297 1.297c0.716 0 1.297-0.581 1.297-1.297 0-0 0-0.001 0-0.001v0c-0.001-0.716-0.581-1.296-1.297-1.297h-0zM18.092 12.162c-0.281 0-0.509-0.228-0.509-0.509s0.228-0.509 0.509-0.509c0.281 0 0.509 0.228 0.509 0.509v0c-0.001 0.28-0.228 0.507-0.509 0.508h-0z"
    />
  </svg>
)
export const IconXTwitter = ({ className }) => (
  <svg
    role="img"
    aria-label={'X Twitter'}
    className={'icon icon-linked-in ' + className}
    version="1.1"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <path
      fill="#007ab7"
      className={'fill-current'}
      d="M24.325 3h4.411l-9.636 11.013 11.336 14.987h-8.876l-6.952-9.089-7.955 9.089h-4.413l10.307-11.78-10.875-14.22h9.101l6.284 8.308zM22.777 26.36h2.444l-15.776-20.859h-2.623z"
    />
  </svg>
)
export const IconLinkedIn = ({ className }) => (
  <svg
    role="img"
    aria-label={'LinkedIn'}
    className={'icon icon-linked-in ' + className}
    version="1.1"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <path
      fill="#007ab7"
      className={'fill-current'}
      d="M12 12h5.535v2.837h0.079c0.77-1.381 2.655-2.837 5.464-2.837 5.842 0 6.922 3.637 6.922 8.367v9.633h-5.769v-8.54c0-2.037-0.042-4.657-3.001-4.657-3.005 0-3.463 2.218-3.463 4.509v8.688h-5.767v-18z"
    />
    <path fill="#007ab7" className={'fill-current'} d="M2 12h6v18h-6v-18z" />
    <path
      fill="#007ab7"
      className={'fill-current'}
      d="M8 7c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"
    />
  </svg>
)
IconFacebook.propTypes = {
  className: PropTypes.string,
}
IconInstagram.propTypes = {
  className: PropTypes.string,
}
IconLinkedIn.propTypes = {
  className: PropTypes.string,
}
IconTwitter.propTypes = {
  className: PropTypes.string,
}
IconYouTube.propTypes = {
  className: PropTypes.string,
}
IconGooglePlus.propTypes = {
  className: PropTypes.string,
}
